import React from 'react';
import './MobileHeaderOrganism.scss';
import UserIdentity from '../../molecules/user-identity/user-identity';
import MetaspaceMenu from '../../molecules/MetaspaceMenu/MetaspaceMenu';
import UserSphere from '../../molecules/user-sphere/user-sphere';
import { useTranslation } from 'localization';

export interface MobileHeaderProps {
  onSearchChange?: (query: string) => void;
  onLogoClick?: () => void;
  showSearch?: boolean;
  placeholder?: string;
  className?: string;
  logoSrc: string; // Logo image source (required)
  logoAlt?: string; // Translation key for logo alt text (default: 'common.logo.alt')
  // UserIdentity props
  identityId?: string; // Sphere ID for UserIdentity
  sphere?: any; // Sphere object for MetaspaceMenu and UserSphere
  metaspaceId?: string; // Metaspace ID for UserSphere
  onSphereChange?: (newSphereId: string) => void; // Callback for UserSphere
  onMetaspaceSelected?: (metaspaceId: string) => void; // Callback for MetaspaceMenu
}

/**
 * MobileHeaderOrganism - Top header bar for mobile view
 * Features: Logo, UserIdentity, search box, and settings icon
 */
const MobileHeaderOrganism: React.FC<MobileHeaderProps> = ({
  onSearchChange,
  onLogoClick,
  showSearch = true,
  placeholder,
  className = '',
  logoSrc,
  logoAlt,
  identityId,
  sphere,
  metaspaceId,
  onSphereChange,
  onMetaspaceSelected
}) => {
  const { t } = useTranslation();

  // Use translations for defaults - logoAlt should be a translation key
  const logoAltText = logoAlt ?? t('common.logo.alt', { defaultValue: 'Center Logo' });


  return (
    <header className={`mobile-header ${className}`}>
      <div className="mobile-header__container">
        {/* Logo */}
        <button
          type="button"
          className="mobile-header__logo-button"
          onClick={onLogoClick}
          aria-label={logoAltText}
        >
          <img
            src={logoSrc}
            alt={logoAltText}
            className="mobile-header__logo"
          />
        </button>

        {/* UserIdentity */}
        {identityId && (
          <div className="mobile-header__user-identity">
            <UserIdentity identityId={identityId} urlSphere={sphere} />
          </div>
        )}



        {/* UserSphere instead of Search Box */}
        {sphere && (
          <div className="mobile-header__user-sphere">
            <UserSphere
              sphereId={sphere.id}
              metaspaceId={typeof metaspaceId === 'string' ? metaspaceId : ''}
              onSphereChange={onSphereChange ?? (() => { /* no-op */ })}
              initialSelectedPath={sphere?.ancestors ? [...sphere.ancestors.map((a: any) => a.properties?.name), sphere.properties?.name].join(' / ') : ''}
            />
          </div>
        )}
        {/* MetaspaceMenu for mobile view */}
        {sphere && (
          <div className="mobile-header__metaspace-menu">
            <MetaspaceMenu
              sphere={sphere}
              metaspaceSelected={onMetaspaceSelected}
              className="nav-bar-button"
              isNavBar={true}
            />
          </div>
        )}
        {/* Settings Icon removed, now handled in MobileNavBar */}
      </div>
    </header>
  );
};

export default MobileHeaderOrganism;
